import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'components/modals';
import {QuickTip, FormLayout, Select2} from 'components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const ExclaimerText = observer(({uiState}) => {
  const {eligibilityRecord, employee} = uiState;

  if (eligibilityRecord.state === 'application_approved') {
    return (
      <QuickTip trait='caution' paragraphs={[
        <FormattedMessage id='benefit_enrolment.APPROVED_EXCLAIMER' 
          values={{
            employee_name: employee.name, 
            coverage_name: t(`models.coverage_types.${eligibilityRecord.coverageType}`)
          }}/>
      ]}/>
    );
  }

  if (eligibilityRecord.state === 'declined_to_apply') {
    return (
      <QuickTip trait='caution' paragraphs={[
        <FormattedMessage id='benefit_enrolment.DECLINED_EXCLAIMER_ONE' 
          values={{
            employee_name: employee.name, 
            coverage_name: t(`models.coverage_types.${eligibilityRecord.coverageType}`)
          }}/>,
        <FormattedMessage id='benefit_enrolment.DECLINED_EXCLAIMER_TWO' />
      ]}/>
    );
  }

  return null;
});

const EligibilityRecordModal = observer(({uiState}) => {
  const {eligibilityRecord} = uiState;
  if (!eligibilityRecord) return null;

  return (
    <Modal title='benefit_enrolment.Update eligibility status'
      isOpen={uiState.eligibilityRecordModalOpen} 
      onHide={() => uiState.closeEligibilityRecordModal()}>
      <FormLayout>
        <Select2 
          label='benefit_enrolment.Employee application status'
          value={eligibilityRecord.state}
          onChange={e => eligibilityRecord.merge({state: e.target.value})}>
          <option value='declined_to_apply'>{t('benefit_enrolment.eligibility_record_states.declined_to_apply')}</option>
          <option value='application_approved'>{t('benefit_enrolment.eligibility_record_states.application_approved')}</option>
        </Select2>
      </FormLayout>
      <ExclaimerText uiState={uiState} />
      <ModalButtons onSave={() => uiState.createEligibilityRecord()}
        onCancel={() => uiState.closeEligibilityRecordModal()}/>
    </Modal>
  );
});

export default EligibilityRecordModal;
